var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87891 10.1201L14.1215 14.3628M9.87891 14.3628L14.1215 10.1201",
    stroke: "#6A796E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.20421C8.86757 3.41302 10.4201 2.99758 12 3.00001C16.9707 3.00001 21 7.02931 21 12C21 16.9707 16.9707 21 12 21C7.0293 21 3 16.9707 3 12C3 10.3611 3.4383 8.82301 4.2042 7.50001",
    stroke: "#6A796E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCross);
export default __webpack_public_path__ + "static/media/circle-cross.aa94800b9933d47c8cec64f52ebb6777.svg";
export { ForwardRef as ReactComponent };